import axios from "axios";

class Register {

	recaptcha(token)
	{
		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/users/recaptcha", {
					token
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error.response);
				});
		});
	}

	register(prenom, nom, email, mot_de_passe, token, fields) {
		return new Promise(function (resolve, reject) {
			//console.log(`${process.env.VUE_APP_SAAS_BACK}` + '/users/login')
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/users/register", {
					prenom,
					nom,
					email,
					mot_de_passe,
					token,
					fields
				})
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error.response.data.msg);
				});
		});
	}

	register_client(prenom, nom, email, mot_de_passe, recaptcha) {
		return new Promise(function (resolve, reject) {
			//console.log(`${process.env.VUE_APP_SAAS_BACK}` + '/users/login')
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/users/register_client", {
					prenom,
					nom,
					email,
					mot_de_passe,
					recaptcha
				})
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error.response.data.msg);
				});
		});
	}

	register_get(token) {
		return new Promise(function (resolve, reject) {
			//console.log(`${process.env.VUE_APP_SAAS_BACK}` + '/users/login')
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/users/register_get", {
					token
				})
				.then(function (response) {
					resolve(response.data.register);
				})
				.catch(function (error) {
					reject(error.response);
				});
		});
	}


	register_check(client_user_uid, token) {
		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/users/register_check", {
					client_user_uid,
					token
				})
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error.response.data.msg);
				});
		});
	}

}

export default new Register();
